module.exports = __webpack_public_path__ + "img/ban4.20e10626.jpg";